import { render, staticRenderFns } from "./MarketingDashboard.vue?vue&type=template&id=4657e024&scoped=true&"
import script from "./MarketingDashboard.vue?vue&type=script&lang=js&"
export * from "./MarketingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MarketingDashboard.vue?vue&type=style&index=0&id=4657e024&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657e024",
  null
  
)

export default component.exports